import { FormArray, FormGroup } from "@angular/forms";
import { BmMgmFeeGroupForm, BmItemForm } from "../../../pojo/bm-form";
import { BmCalcType } from "../../../pojo/bm-enums";
import { BmCalcHelperService } from "../../general/bm-calc-helper.service";
import { BmDefaultFormCreatorService } from "../../general/bm-default-form-creator.service";
import { BmItem } from "../../../pojo/bm-classes";

/**
 * SERVICE TO CALCULATE MGM FEE GROUP TOTAL VALUES
 */
export class BmGroupTotalCalculationsService {

  public static createTotalMgmForm(yearsNumber: number): FormArray<FormGroup<BmItemForm>> {
    const items: BmItem[] = BmDefaultFormCreatorService.createItemsArray(yearsNumber);

    return new FormArray<FormGroup<BmItemForm>>(
      items.map((data) => BmCalcHelperService.createBmItemForm(data))
    );
  }

  public static groupTotalRecalculate(mgmFeeGroupFG: FormGroup<BmMgmFeeGroupForm>): void {
    const totalFA = mgmFeeGroupFG.controls.total;
    const totalRowValue = mgmFeeGroupFG.controls.totalRow;

    const vatArray = mgmFeeGroupFG.controls.subGroups.controls.vatValues.controls.items;
    const mgmFeeArray = mgmFeeGroupFG.controls.subGroups.controls.mgmFeeValues.controls.items;
    const catchUpArray = mgmFeeGroupFG.controls.subGroups.controls.catchUp.controls.items;
    const isCatchUpSelected = mgmFeeGroupFG.controls.subGroups.controls.catchUp.controls.isSelected.getRawValue();
    const isVatSelected = mgmFeeGroupFG.controls.subGroups.controls.vatPcnt.controls.isSelected.getRawValue();

    totalFA.controls.forEach((total, i) => {
      const period = total.value.period;

      const mgmFeeVal = BmCalcHelperService.findItem(mgmFeeArray, period.quarterNumber, period.yearNumber).getRawValue().itemValue;
      const catchUpVal = isCatchUpSelected ? BmCalcHelperService.findItem(catchUpArray, period.quarterNumber, period.yearNumber).getRawValue().itemValue : 0;
      const vatVal = isVatSelected ? BmCalcHelperService.findItem(vatArray, period.quarterNumber, period.yearNumber).getRawValue().itemValue : 0;

      const totalValue = mgmFeeVal + catchUpVal + vatVal;

      const totalItemFG = totalFA.at(i);
      totalItemFG.patchValue(
        {
          period: period,
          itemValue: totalValue,
          calcType: BmCalcType.CALCULATED,
        },
        { emitEvent: false }
      );
    });

    const groupTotalRowValue = BmCalcHelperService.recalculateRowTotal(totalFA);
    totalRowValue.patchValue(groupTotalRowValue, { emitEvent: false });
  }
}
